/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2022
 * @format
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import newIcon from '../../../../../../../assets/images/Fireboard/new.png';
import classes from './CheckContent.module.css';

const CheckContent = ({ check, managerMode, fbVenueMode }) => {
  const {
    phoneNumber,
    checkNumber,
    color,
    status,
    isNew,
    relatedNotifications,
    ellapsedTime,
    ellapsedTimeColor,
    dueTime,
    checkInTime,
    deliverTo,
    slotName,
    venueName,
  } = check;

  const renderStatus = () => {
    const hasIdCheckNotification = relatedNotifications && relatedNotifications.filter(n => n.notificationTypeId === 14);
    return (
      managerMode ? (
        hasIdCheckNotification && hasIdCheckNotification.length > 0
          ? <span>ID CHECK</span>
          : null
      ) : (
        <React.Fragment>
          <span style={{ color }}>{` ${status}`}</span>
          {isNew && <img src={newIcon} className={classes.newIcon} alt="new" />}
        </React.Fragment>
      )
    )
  };

  const deliverToAndSlotName = slotName ? `${deliverTo}\n[${slotName}]` : deliverTo;

  return (
    <div className={classes.container}>
      {fbVenueMode && (
        <div className={classes.label}>
          {venueName}
        </div>
      )}
      <div className={classes.label}>
        Number: {phoneNumber} {checkNumber}
      </div>
      <div className={classes.label}>
        Status: {renderStatus()}
      </div>
      <div className={classes.label}>
        Time: <span style={{ color: ellapsedTimeColor }}>{ellapsedTime}</span>
      </div>
      <div className={classes.label}>
        Due: {dueTime}
      </div>
      <div className={classes.label}>
        Check In: {checkInTime}
      </div>
      <div className={classes.label}>
        Delivery To: {deliverToAndSlotName}
      </div>
    </div>
  )
};

export default CheckContent;

CheckContent.propTypes = {
  check: PropTypes.object,
  managerMode: PropTypes.bool,
  fbVenueMode: PropTypes.bool,
};

CheckContent.defaultProps = {
  check: {},
  managerMode: false,
  fbVenueMode: false,
};
